module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', {
    staticClass: "links"
  }, _vm._l((_vm.social), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('i', {
      class: ("fa fa-" + (item.name))
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.2@vue-loader/lib/template-compiler?{"id":"data-v-00d97c1e"}!./~/.11.3.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 153
// module chunks = 1